export const ItemTypes = {
  STATEMENT:  'STATEMENT',
  EXPRESSION: 'EXPRESSION',
};
